import { gql } from 'react-apollo';

export default gql`
  mutation createRealexInvestorUser(
    $input: CreateRealexInvestorUserInput!
  ) {
    createRealexInvestorUser(input: $input) {
      _id
      firstName
      lastName
      email
      offerId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/createRealexInvestorUser.js